<template lang="pug">
UiModal(
  :show="show"
  @close="close"
  :title="$t('super_admins.edit')"
  :rightActions="rightActions"
)
  UiFormGroup(
    :label="$t('super_admins.name')"
    :vuelidateModel="v$.form.name"
  ) 
    UiInput#name-input(
      v-model="form.name"
      :error="v$.form.name.$error"
    )

  UiFormGroup(
    :label="$t('super_admins.email')"
    :vuelidateModel="v$.form.email"
  )
    UiInput#email-input(
      v-model="form.email"
      type="email"
      :error="v$.form.email.$error"
    )
</template>

<script>
import useVuelidate from "@vuelidate/core";
import SuperAdmin from "../../models/SuperAdmin";
import ApiSuperAdmins from "@/api/super_admins.js";
import { email, required } from "@vuelidate/validators";

export default {
  setup() {
    return {
      v$: useVuelidate(),
    };
  },

  validations() {
    return {
      form: {
        name: {
          required,
        },
        email: {
          required,
          email,
        },
      },
    };
  },

  data() {
    return {
      show: false,
      form: new SuperAdmin(),
    };
  },

  computed: {
    rightActions() {
      return [
        {
          label: this.$t("actions.save"),
          icon: "Check",
          onClick: this.save,
        },
      ];
    },
  },

  methods: {
    open(admin) {
      this.v$.$reset();
      this.form = new SuperAdmin(admin);
      this.show = true;
    },

    close() {
      this.show = false;
    },

    save() {
      this.v$.$validate().then((res) => {
        if (!res) return;
        const form = this.form;
        ApiSuperAdmins.save({ name: form.name, email: form.email })
          .then((res) => {
            this.$emit("done");
            this.close();
          })
          .catch((e) => {});
      });
    },
  },
};
</script>
